/**
 * @file DAO 的插件
 * @description
 *    在拼装 API 前参数命名驼峰化
 *    在拼装 API 后参数命名下划线
 *    以支持在 APIConfig 中两种命名方式混用
 */

import { APIPlugin, ParamKeyObject } from '../index';

const snake2camel = (snake: string): string => snake.replace(/_(\w)/g, (all, letter) => letter.toUpperCase());

const camel2snake = (camel: string): string => camel.replace(/([A-Z])/g, '_$1').toLowerCase();

const transform = (transformRule: Function) => (params: ParamKeyObject) =>
  new Promise(resolve => {
    Object.keys(params).forEach(key => {
      const transformedKet = transformRule(key);
      params[transformedKet] = params[key];
    });
    resolve(params);
  });

/**
 * 下划线 -> 驼峰
 */
export const snake2camelPlugin: APIPlugin = async (apiSetName, apiName, paramsObject) => {
  const { incomingParams, autoParams, defaultParams } = paramsObject;
  const fn = transform(snake2camel);
  await Promise.all([fn(incomingParams), fn(autoParams), fn(defaultParams)]);
  return paramsObject;
};

/**
 * 驼峰 -> 下划线
 */
export const camel2snakePlugin: APIPlugin = async (apiSetName, apiName, paramsObject) => {
  const { incomingParams, autoParams, defaultParams } = paramsObject;
  const fn = transform(camel2snake);
  await Promise.all([fn(incomingParams), fn(autoParams), fn(defaultParams)]);
  return paramsObject;
};
